module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-300italic.woff2?6725c3fb1f3abd7ebdcb2d244758f706";